module.exports = __webpack_public_path__ + "img/domains.c26de998.svg";